// extracted by mini-css-extract-plugin
module.exports = {"container":"idt-numberinputbuttons_container__txxj-","button":"idt-numberinputbuttons_button__1hndv","input":"idt-numberinputbuttons_input__33ne3"};